<template>
  <v-container class="mb-12 mt-0 mt-md-12" id="feedbacks">
    <h2
      class="text-md-h4 text-h5 font-weight-medium"
      style="background-image: linear-gradient(90deg, rgba(35,165,78,1) 0%, rgba(130,169,60,1) 48%, rgba(251,213,69,1) 89%); background-clip: text; color: transparent;"
    >
      อยากบอกอะไรกับผู้พัฒนา Repttown
    </h2>

    <div class="mt-2 text-body-2 font-weight-light grey--text text--lighten-2">
      ร่วมเป็นส่วนหนึ่งในการพัฒนา Repttown โดยการเสนอฟีเจอร์ใหม่ ๆ
      ที่คุณต้องการเห็นในอนาคต
      เรารับฟังความเห็นและไอเดียของคุณเพื่อปรับปรุงและพัฒนาฟีเจอร์ต่าง ๆ
      ให้ตรงกับความต้องการของคุณมากที่สุด
      ช่วยเราในการสร้างประสบการณ์ที่ดีที่สุดให้ชุมชน Repttown
    </div>

    <div v-if="!(mergeFeedbacks.length || isLogged)" class="mt-4">
      <v-btn rounded outlined color="white" to="/login">
        เข้าสู่ระบบเพื่อส่งความคิดเห็น
      </v-btn>
    </div>

    <div
      v-else
      class="mt-6 pa-md-6 pa-4 rounded-xl"
      style="background-image: radial-gradient(circle 1292px at -13.6% 51.7%, rgba(1,25,24,1) 0%, rgba(25,46,30,1) 61.5%, rgba(17,32,27,1) 98% ); box-shadow: rgba(26,48,31,0.35) 0px 5px 15px;"
    >
      <template v-if="mergeFeedbacks.length">
        <div class="mb-4 text-body-1">ความคิดเห็นยอดนิยม</div>
        <div class="mx-n2 mt-n2 mb-2 d-flex flex-wrap">
          <v-card
            v-for="(feedback, i) in mergeFeedbacks"
            :key="i"
            flat
            class="ma-2 px-2 py-1 rounded-lg"
            min-width="80"
            style="background: rgba(70,132,127,.2)"
          >
            <div class="text-body-2">{{ feedback.message }}</div>
            <div class="mt-2 d-flex align-center">
              <span v-if="feedback.isMyFeedback" class="text-caption"
                >(You)</span
              >
              <v-spacer></v-spacer>
              <v-btn
                x-small
                icon
                @click="likeFeedback(feedback._id, !feedback.isLike)"
                :disabled="loading"
              >
                <v-icon small>{{
                  feedback.isLike ? "mdi-heart" : "mdi-heart-outline"
                }}</v-icon>
              </v-btn>
              <span class="text-caption">{{ feedback.likeCount }}</span>
            </div>
          </v-card>
        </div>
      </template>

      <div v-if="isLogged" class="mb-n2 d-flex align-center">
        <v-text-field
          label="ส่งความคิดเห็น (ส่งได้สูงสุด 10 รายการ)"
          counter="200"
          v-model="message"
          :disabled="isSubmitDisabled"
        ></v-text-field>
        <v-btn
          class="ml-3 mb-2"
          style="background: #1c673a;"
          @click="submitFeedback()"
          :disabled="isSubmitDisabled"
        >
          ส่ง
        </v-btn>
      </div>
      <div v-else class="mt-4 text-center">
        <v-btn text style="background: #1c673a;" to="/login">
          เข้าสู่ระบบเพื่อส่งความคิดเห็น
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import feedback from "@/services/feedback"
import api from "@/services/api"

export default {
  name: "FeedbackSection",
  data() {
    return {
      pinnedFeedbacks: [],
      userFeedbacks: [],
      message: "",
      loading: false,
    }
  },
  mounted() {
    this.getFeedbacks()
  },
  methods: {
    async getFeedbacks() {
      this.loading = true

      try {
        const result = await feedback.getFeedbacks()
        this.pinnedFeedbacks = result.pinnedFeedbacks
        this.userFeedbacks = result.userFeedbacks
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    async likeFeedback(id, like) {
      try {
        this.loading = true
        await feedback.likeFeedback(id, like)
      } catch (error) {
      } finally {
        this.loading = false
        this.getFeedbacks()
      }
    },
    async submitFeedback() {
      this.loading = true
      try {
        await feedback.sendFeedback(this.message)
        this.message = ""
        this.getFeedbacks()
        api.makeAlert("ข้อความถูกส่งแล้ว", "success")
        setTimeout(
          () => api.makeAlert("ขอบคุณสำหรับความคิดเห็น 🙏🏻", "primary"),
          2500
        )
      } catch (e) {
        api.makeAlert("เกิดข้อผิดพลาดในการส่งข้อความ", "error")
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    ...mapState(["userInfo", "isLogged"]),
    isSubmitDisabled() {
      return this.loading || this.userFeedbacks.length >= 5
    },
    mergeFeedbacks() {
      const feedbacksDict = {}
      this.pinnedFeedbacks.forEach(feedback => {
        feedbacksDict[feedback._id] = feedback
      })

      // Remove user feedbacks in pinned feedbacks
      this.userFeedbacks.forEach(myFeedback => {
        delete feedbacksDict[myFeedback._id]
        myFeedback.isMyFeedback = true
      })

      let feedbacks = Object.values(feedbacksDict)

      // Sort by likeCount then by message length
      feedbacks.sort((a, b) => {
        // if (a.likeCount !== b.likeCount) {
        //   return b.likeCount - a.likeCount
        // }
        return a.message.length - b.message.length
      })

      // Add user feedbacks to the end
      feedbacks = feedbacks.concat(this.userFeedbacks)

      return feedbacks
    },
  },
}
</script>

<!-- <v-row v-if="false" class="mt-2">
  <v-col cols="12" sm="6">
    <div class="mb-4 text-body-1">ความคิดเห็นยอดนิยม</div>
    <div class="ma-n2 d-flex flex-wrap">
      <v-card
        v-for="(feedback, i) in pinnedFeedbacks"
        :key="i"
        flat
        class="ma-2 px-2 py-1 rounded-lg"
        min-width="80"
        style="background: rgba(70,132,127,.2)"
      >
        <div class="text-body-2">{{ feedback.message }}</div>
        <div class="mt-2 d-flex align-center">
          <span v-if="feedback.isMyFeedback" class="text-caption"
            >(You)</span
          >
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            @click="likeFeedback(feedback._id, !feedback.isLike)"
            :disabled="loading"
          >
            <v-icon small>{{
              feedback.isLike ? "mdi-heart" : "mdi-heart-outline"
            }}</v-icon>
          </v-btn>
          <span class="text-caption">{{ feedback.likeCount }}</span>
        </div>
      </v-card>
      <div
        v-if="!pinnedFeedbacks.length"
        class="mx-2 mt-4 grey--text text-body-2"
      >
        ไม่มีความคิดเห็น
      </div>
    </div>
  </v-col>
  <v-col cols="12" sm="6">
    <template v-if="isLogged">
      <p class="text-body-1">
        ความคิดเห็นของคุณ (ส่งได้สูงสุด 5 รายการ)
      </p>
      <v-card
        v-for="(feedback, i) in userFeedbacks"
        :key="i"
        flat
        class="my-4 pa-2 rounded-lg"
        style="background: rgba(70,132,127,.2)"
      >
        <div class="text-body-2">{{ feedback.message }}</div>
      </v-card>
      <v-textarea
        label="ส่งความคิดเห็น"
        full-width
        height="140"
        outlined
        counter="200"
        v-model="message"
      ></v-textarea>
      <div class="mt-1 text-right">
        <v-btn
          style="background: #1c673a;"
          @click="submitFeedback()"
          :disabled="loading"
        >
          ส่งความคิดเห็น
        </v-btn>
      </div>
    </template>
    <template v-else>
      <p class="text-body-1">ส่งความคิดเห็นของคุณ</p>
      <v-btn style="background: #1c673a;" to="/login">
        เข้าสู่ระบบเพื่อส่งความคิดเห็น
      </v-btn>
    </template>
  </v-col>
</v-row> -->
